import React, { useEffect, useState, useRef, useCallback } from 'react'
import Api from '../../../_helpers/Api'
import { useParams, useHistory, useLocation } from 'react-router-dom'

import loader from '../../../assets/img/loader.svg'
import { useAuthDataContext } from '../../../_providers/Auth'
import Table from './partials/Table'
import Filter from './partials/Filter'
import update from 'immutability-helper'
import Address from './partials/Address'
import { fromInfo, trans } from '../../../_providers/Translation'
import Help from '../../partials/Help'
import TechLocationModal from './partials/TechLocationModal'
import WeekTabs from './partials/WeekTabs'

// images
import workerNearbyImage from "@/assets/img/schedule/icons/worker-nearby.svg"
import workersLocationImage from "@/assets/img/schedule/icons/workers-location.svg"

// styles
import "@/assets/scss/pages/schedule.scss"

let timeout

function Schedule(props) {

    const auth = useAuthDataContext()
    const location = useLocation()
    const history = useHistory()
    const params = useParams()

    const searchParams = new URLSearchParams(location.search)

    const addressModalRef = useRef(null)
    const techLocationRef = useRef(null)
    const initialized = useRef(false)

    const [data, setData] = useState({
        loading: true,
        data: [],
        filter: {
            start: '',
            end: '',
            employees: [],
            search: ''
        },
        update: false,
        dragId: null,
        dropId: null,
    })

    useEffect(() => {

        setData(prev => ({
            ...prev,
            filter: {
                start: searchParams.get('start') || '',
                // end: searchParams.get('end') || '',
                employees: searchParams.getAll('employees[]') || [],
                search: searchParams.get('search') || '',
                group_id: searchParams.get('group_id') || '',
                category_id: searchParams.get('category_id') || '',
            },
            update: new Date().getTime(),
        }))

    }, [location.search])

    useEffect(() => {

        if (data.setFilter) {

            Object.entries(data.filter).map(filter => {

                if (Array.isArray(filter[1])) {
                    let name = filter[0] + '[]'

                    searchParams.delete(name)

                    filter[1].map(v => {
                        searchParams.append(name, v)
                    })

                } else {
                    searchParams.set(filter[0], filter[1])
                }

            })

            history.push('?' + searchParams.toString())
        }

    }, [data.setFilter])


    useEffect(() => {
        loadData()
    }, [data.update])

    // read
    const loadData = () => {
        setData(prev => ({
            ...prev,
            loading: true
        }))

        if (initialized.current && searchParams.getAll('employees[]').length === 0) {
            setData(prev => ({
                ...prev,
                loading: false,
                data: {
                    ...prev.data,
                    employees: [],
                    employees_ids: [],
                    reservations: []
                }
            }))
            return
        }

        let url = 'reservations/schedule?' + searchParams.toString()

        Api.get(url)
            .then(res => {
                initialized.current = true
                setData(prev => ({
                    ...prev,
                    data: res.data,
                    filter: {
                        ...prev.filter,
                        start: res.data.start,
                        employees: res.data.employees_ids,
                        end: res.data.end,
                    },
                }))
            })
            .finally(() => {
                setData(prev => ({
                    ...prev,
                    loading: false
                }))
                if (addressModalRef.current) addressModalRef.current.cancelLoading()
            })
    }

    const handleEmployees = ids => {
        setData(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                employees: ids,
                group_id: null
            },
            setFilter: new Date().getTime()
        }))
    }

    const handleGroup = id => {
        setData(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                employees: id === '' ? [] : prev.filter.employees,
                group_id: id
            },
            setFilter: new Date().getTime()
        }))
    }

    const handleSearch = (key, val) => {

        clearTimeout(timeout)

        setData(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            }
        }))

        timeout = setTimeout(() => {
            setData(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, 300)

    }

    const moveCard = useCallback(
        (dragCard, hoverCard) => {

            let obj = [...data.data.reservations]

            let dragIndex = obj.findIndex(r => Number(r.id) === Number(dragCard.id))
            let hoverIndex = obj.findIndex(r => Number(r.id) === Number(hoverCard.id))
            setData(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    reservations: update(data.data.reservations, {
                        $splice: [
                            [dragIndex, 1],
                            [hoverIndex, 0, dragCard],
                        ],
                    })
                },
                dragId: dragCard.id,
                dropId: hoverCard.id
            }))
        },
        [data.data]
    )

    const changePriority = ids => {
        // Api.post('reservations/set-priority', { ids: [data.dragId, data.dropId] });
        Api.post('reservations/set-priority', { ids: ids })
    }

    const showMap = () => {
        addressModalRef.current.open()
    }

    const showTechMap = () => {
        if (techLocationRef.current) techLocationRef.current.open()
    }



    return (
        <>

            <div className="wrapper">
                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.schedule')}
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.schedule')}
                        </p>
                    </div>
                    <div className="right" style={{ display: 'flex' }}>
                        <button onClick={showMap} className='button button-default'>
                            <img src={workerNearbyImage} />
                            {trans('labels.technicianClose')}
                        </button>

                        <button
                            className="button button-default"
                            style={{ marginLeft: 8 }}
                            onClick={showTechMap}
                        >
                            <img src={workersLocationImage} />
                            {trans('random.employeesLocation')}
                        </button>
                    </div>
                </div>

                <Address
                    ref={addressModalRef}
                    selected={data.filter.search}
                    filter={data.filter}
                    reservations={data.data.reservations}
                    employees={data.data.employees}
                    handleSearch={handleSearch}
                />

                <WeekTabs
                    data={data.filter}
                    handleSearch={handleSearch}
                />
                <div className='pannel'>
                    <Filter
                        data={data.filter}
                        handleSearch={handleSearch}
                        handleGroup={handleGroup}
                        handleEmployees={handleEmployees}
                        showMap={showMap}
                        showTechLocations={showTechMap}
                    />
                    <hr />
                    <Table
                        data={data.data}
                        loading={data.loading}
                        moveCard={moveCard}
                        changePriority={changePriority}
                    />
                    <TechLocationModal ref={techLocationRef} />
                </div>
            </div>
        </>
    )
}

export default Schedule